import * as React from "react"

import { get } from 'lodash'
import { TableBody, TableCell, TableRow, cn } from 'twyne-new.ui';

const Body = ({ data, columns, rowClassName, keyField, rowWrapper, fixedFistColumnOnScroll = false }) => {
  const RowWrapper = rowWrapper || TableRow
  return <>
    <TableBody className='overflow-x-auto'>
      {data.map((row, rowIndex) => {
        const rowKey = keyField ? row[keyField] : rowIndex
        return <RowWrapper
          className={`${rowClassName ? rowClassName(row) : undefined} ${rowIndex % 2 && 'twy-bg-base'}`}
          key={rowKey}
          row={{ ...row, index: rowIndex }}
        >
          {columns.map((column, colIndex) => <>
            <TableCell
              key={colIndex}
              className={cn(
                'truncate max-w-80',
                column.className,
                fixedFistColumnOnScroll && colIndex === 0 && 'sticky left-0 z-20 shadow-[1px_0_0_0_theme(colors.gray.300)] dark:shadow-[1px_0_0_0_theme(colors.gray.1200)]',
                fixedFistColumnOnScroll && colIndex === 0 && (rowIndex % 2 ? 'twy-bg-base' : 'twy-bg-base-accent'),
              )}
            >
              {column.formatter ? column.formatter(get(row, column.dataField), row, rowIndex) : get(row, column.dataField)}
            </TableCell>
          </>)}
        </RowWrapper>
      })}
    </TableBody>
  </>
}

export default React.memo(Body)
